import { Link } from '@eleveo/components-react';
import { UserIcon } from '@eleveo/icons-react';
import React from 'react';

export interface FooterLinkType {
  icon?: JSX.Element;
  text: string;
  to: string;
  testId: string;
  name: string;
}

export interface ManageAccountProps {
  userName: string;
  links: FooterLinkType[];
}

export const ManageAccountDropdown: React.FC<ManageAccountProps> = ({ userName, links }) => {
  return (
    <div className="manage-accounts">
      <div className="manage-accounts__user-name flex items-center justify-start">
        <div className="manage-accounts__button-wrapper flex items-center justify-center rounded-full">
          <UserIcon className="manage-accounts__user-icon" />
        </div>
        <p>{userName}</p>
      </div>
      <ul className="manage-accounts__list">
        {links.map(({ icon, text, to, testId }) => (
          <li key={to} className="manage-accounts__link">
            <Link href={to} className="flex items-center justify-start" testId={testId}>
              {icon}
              <p>{text}</p>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};
